var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { Question } from "../../shared/models/question";
import { QuestionComponent } from "../question/question.component";
import { QuestionType } from "../../shared/models/question-type";
var QuestionChecklistComponent = /** @class */ (function (_super) {
    __extends(QuestionChecklistComponent, _super);
    function QuestionChecklistComponent() {
        return _super.call(this) || this;
    }
    QuestionChecklistComponent.prototype.ngOnInit = function () {
        if (this.question && this.question.type == QuestionType.Checklist) {
            this._checklistQuestion = this.question;
        }
    };
    QuestionChecklistComponent.prototype.updateAnswers = function (label, event) {
        event.stopPropagation();
        event.preventDefault();
        if (event.currentTarget.checked) {
            this._checklistQuestion.removeAnswer(label);
        }
        else {
            this._checklistQuestion.addAnswer(label);
        }
        this.notifyAnswered();
        // this.question.answer = answer;
    };
    QuestionChecklistComponent.prototype.isAnswer = function (label) {
        return this._checklistQuestion.hasAnswer(label);
    };
    Object.defineProperty(QuestionChecklistComponent.prototype, "Question", {
        get: function () {
            return this._checklistQuestion;
        },
        enumerable: true,
        configurable: true
    });
    return QuestionChecklistComponent;
}(QuestionComponent));
export { QuestionChecklistComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/question-checklist/question-checklist.component.ts.pre-build-optimizer.js